/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PagedResponse } from "models/paged-response";
import { GetComplaintsPaginatedRequest, GetComplaintsPaginatedState, PaginatedComplaint } from "store/modules/complaints/types";

const initialState: GetComplaintsPaginatedState = {
    isRequesting: false,
    successPayload: {
        hasNextPage: false,
        hasPreviousPage: false,
        indexFrom: 0,
        items: [],
        pageIndex: 0,
        pageSize: 10,
        totalCount: 0,
        totalPages: 0
    },
    errors: []
};

const getComplaintsPaginatedSlice = createSlice({
    name: "complaints@getComplaintsPaginated",
    initialState,
    reducers: {
        getComplaintsPaginatedRequest: (
            state,
            action: PayloadAction<GetComplaintsPaginatedRequest>
        ): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        getComplaintsPaginatedSuccess: (
            state,
            action: PayloadAction<PagedResponse<PaginatedComplaint>>
        ): void => {
            state.isRequesting = false;
            state.successPayload = action.payload;
        },
        getComplaintsPaginatedFailed: (
            state,
            action: PayloadAction<string[]>
        ): void => {
            state.isRequesting = false;
            state.errors = action.payload;
        }
    }
});

export const {
    getComplaintsPaginatedFailed,
    getComplaintsPaginatedRequest,
    getComplaintsPaginatedSuccess
} = getComplaintsPaginatedSlice.actions;
export default getComplaintsPaginatedSlice.reducer;
